import React from "react";

export default function Cargando() {
    return (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "100%" }}>
            <i className="fas fa-spinner fa-spin fa-5x" style={{ color: "#753183", marginTop: "300px" }}></i>
        </div>
    );
}
